import React from "react"
import { FormProvider } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { AvaGaebPhase } from "shared/types/AvaGaebPhase"
import { FormProviderProps } from "shared/types/ReactHookForm"
import { SelectOption } from "shared/types/Select"
import { Select } from "shared/ui/input/select/select/Select"
import { FormOverlay } from "shared/ui/overlay/FormOverlay"

import { ProjectGaebExportFormData } from "./ProjectGaebOverlay"

export interface ProjectGaebOverlayViewModel {
  autoFocus?: boolean
  form: FormProviderProps<ProjectGaebExportFormData>
  options: SelectOption<AvaGaebPhase>[]
  onSubmit: () => void
  onCancel: () => void
}

export const ProjectGaebOverlayView = React.memo(
  ({
    form,
    autoFocus = false,
    onSubmit,
    onCancel,
    options
  }: ProjectGaebOverlayViewModel) => {
    const { t } = useTranslation()

    return (
      <FormOverlay
        id="project-gaeb-export-overlay"
        form="project-gaeb-export-form"
        headline={t("Project.Actions.ExportGAEB")}
        className="form-overlay--small"
        onCancel={onCancel}
        submitButtonText={t("General.Export")}
        cancelButtonText={t("General.Cancel")}
        showCloseButton
      >
        <FormProvider {...form}>
          <form
            id="project-gaeb-export-form"
            className="overlay-form"
            onSubmit={onSubmit}
          >
            <Select.Root
              name="phase"
              label={t("ProjectExport.GAEBExportPhase")}
              autoFocus={autoFocus}
            >
              <Select.Input id="project-gaeb-export-select" options={options} />
            </Select.Root>
          </form>
        </FormProvider>
      </FormOverlay>
    )
  }
)
